import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import GoBackButton from '../../../../../components/GoBackButton';
import axiosInstance from '../../../../../services/AxiosInstance';
import './Candidates.css';


const Candidates = () => {
    const { jobId } = useParams()
    const [candidates, setCandidates] = useState([]);
    const [payment, setPayment] = useState(false);

    useEffect(() => {
        axiosInstance.get(`can-applyjob/payment-status/${jobId}/`).then(res => { setPayment(res?.data) })
        axiosInstance('can-applyjob/?job=' + jobId, { method: 'GET' })
            .then(res => setCandidates(res.data.results))
        // eslint-disable-next-line
    }, []);

    return (
        <div className="page-content bg-white">
            <div className="content-block">
                <div className="section-full bg-white p-b20">
                    <div className="container">
                        <div className="job-bx browse-job clearfix ">
                            <div class="d-flex justify-content-between mb-3">
                                <div className="h5 font-weight-bold">Applied Candidates </div>
                                <div>
                                    <GoBackButton />
                                </div>
                            </div>
                            <div class="container mb-3">
                                {
                                    candidates.length > 0 &&
                                    candidates?.map(candidate => {
                                        return (
                                            <div class="card p-3 mb-2">
                                                <div class="d-flex justify-content-between">
                                                    <div class="d-flex flex-row align-items-center">
                                                        <div className="icon">
                                                            <img src={payment ? candidate?.pimg : ""} alt="" />
                                                        </div>
                                                        <div class="ml-2 c-details">
                                                            <h6 class="mb-0">{payment ? candidate?.name : "Pay to to view the candidate"}</h6> <span>
                                                                {candidate?.city}, {candidate?.country} • {candidate?.age} years old • <span className="text-success font-weight-bold"> {candidate?.can_pro_title} </span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {payment && <div class="badge pointer"> <span>
                                                        <Link to={`/emp-candidate/${candidate.id}`}>View</Link>                                                                                </span> </div>}
                                                </div>
                                                <div className="text1">
                                                    {
                                                        candidate?.experiences?.length > 0 &&
                                                        <>
                                                            <div class="d-flex bd-highlight">
                                                                <div class="p-2 flex-shrink-1 bd-highlight"><i className="fa fa-briefcase" title="Experiences" /></div>
                                                                <div class="p-2 w-100 bd-highlight">
                                                                    {candidate?.experiences?.map(experience =>
                                                                        <span> <b> {experience?.job_categories__name} </b> - <i> {experience?.started_from} to {experience?.ended_on}</i> <br /> </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </>
                                                    }
                                                    {
                                                        candidate?.degrees?.length > 0 &&
                                                        <>
                                                            <div class="d-flex bd-highlight">
                                                                <div class="p-2 flex-shrink-1 bd-highlight"><i className="fa fa-graduation-cap" title="Degrees" /></div>
                                                                <div class="p-2 w-100 bd-highlight">
                                                                    {candidate?.degrees?.map(degree =>
                                                                        <> <b> {degree?.degree__name} </b> - <i> {degree?.university_name} & {degree?.percentage}%</i> <br /></>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </>
                                                    }
                                                    <div class="d-flex bd-highlight">
                                                        <div class="p-2 flex-shrink-1 bd-highlight"><i className="fa fa-book" title="Highlights" /></div>
                                                        <div class="p-2 w-100 bd-highlight">
                                                            <b> Skills </b> {candidate?.skills?.join(", ")}
                                                            <b> Trainings </b> {candidate?.trainings?.join(", ")}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )

                                    })
                                }
                                {candidates.length === 0 &&
                                    <div class="card p-3 mb-2 text-center">
                                        No Candidates Applied Yet
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Candidates;